<script lang="ts" setup>
import AppMenu from './AppMenu.vue'

const { collaborator } = useAuth()
const { toggleMenu } = useTemplateLayout()
</script>

<template>
  <div class="layout-sidebar">
    <div class="flex justify-end py-5 lg:hidden">
      <Button icon="pi pi-times" rounded variant="text" @click="toggleMenu" />
    </div>

    <app-menu :key="collaborator ? collaborator.id : '0'"></app-menu>
  </div>
</template>
